import * as S from "./styled";
import { useForm, SubmitHandler } from "react-hook-form";
import axiosInstance from "services/axiosInstance";
/**
 * Components
 */
import LayoutWithList from "../../../LayoutModal/WithList";
import ActionButton from "../../../Button/ActionButton";
import Loading from "../../../Loading";
/**
 * hooks
 */
import apiRequest from "../../../../hooks/apiRequest";
import { useEffect } from "react";
import useLoading from "../../../../hooks/useLoading";
/**
 * Intefaces
*/
import { ICreate, Inputs } from "Interfaces/IQuantity";

export default function Update({
  isOpenModalQtd,
  setModalClose,
  updateList,

  selectedUrlId,
  selectedSpherId,
  selectedCylinId,
}: ICreate) {
  const {
    register,
    handleSubmit: handleFormSubmit,
    setValue,
    formState: { errors },
  } = useForm<Inputs>();

  const { isLoading, startLoading, stopLoading } = useLoading();

  useEffect(() => {
    const fetchData = async () => {
      startLoading();
      try {
        if (selectedUrlId !== null) {
          const response = await axiosInstance.get(
            `single-vision/${selectedUrlId}`
          );

          const addressData = response.data;
          for (const key in addressData) {
            setValue(key as keyof Inputs, addressData[key]);
          }
        } else {
          console.log("Dado não encontrado!");
        }
      } catch (error) {
        console.log("Error: ", error);
      } finally {
        stopLoading();
      }
    };
    fetchData();
  }, [selectedUrlId]);

  const onSubmit: SubmitHandler<Inputs> = async (data) => {
    startLoading();
    // AQUI
    console.log('Data:' + data);
    try {
      const payload = {
        quantity: data.quantity,
        cropped_lens: data.cropped_lens
      }
      const response = await apiRequest(
        `single-vision/${selectedUrlId}`,
        "PATCH",
        payload
      );
      if (response.status === 200) {
        updateList();
        setModalClose();
      }
    } catch (error: any) {
      alert(error.message || "Ocorreu um erro ao criar o antirreflexo.");
    } finally {
      stopLoading();
    }
  };

  if (isOpenModalQtd) {
    return (
      <LayoutWithList
        title="Atualizar Quantidade"
        subTitle="Atualize as informações da quantidade em sua base de dados."
        setModalClose={setModalClose}
      >
        {isLoading ? (
          <Loading />
        ) : (
          <S.Container>
            <p>Esférico: {selectedSpherId} / Cilindro: {selectedCylinId}</p>
            <S.SeparateDiv>
              <S.FormInput>
                <S.Label>
                  Quantidade
                  <span>*</span>
                </S.Label>
                <S.Input
                  placeholder="0"
                  type="number"
                  {...register("quantity", { required: true })}
                />
                {errors.quantity && <S.InforErro>Campo Obrigatório</S.InforErro>}
              </S.FormInput>

              <S.FormInput>
                <S.Label>
                  Quantidade Cortada
                </S.Label>
                <S.Input
                  placeholder="0"
                  type="number"
                  {...register("cropped_lens")}
                />
              </S.FormInput>

              <S.ContentButton>
                <ActionButton
                  type="submit"
                  name="Atualizar"
                  onClick={handleFormSubmit(onSubmit)}
                />
              </S.ContentButton>
            </S.SeparateDiv>
          </S.Container>
        )}
      </LayoutWithList>
    );
  }
  return null;
}
